// extracted by mini-css-extract-plugin
export default {"alert":"style_alert__ymlqU","active":"style_active__3B6kC","background":"style_background__fNYv1","contentContainer":"style_contentContainer__lhXFa","close":"style_close__e4dPJ"};